export const PROMO_DISCOUNT_TYPE = '113';
export const SHIPPING_AWARD_TYPE = 'Shipping';
